import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { VoucherSearch } from '../../../models/vouchers/voucher-search';
import { IVoucherSearchResult } from '../../../models/vouchers/voucher.search.result';
import { VoucherService } from '../../../services/voucher-service';
import { DialogEditVoucherComponent } from './voucher-edit-dialog';

@Component({
  selector: 'list-vouchers',
  templateUrl: './list-vouchers.component.html',
  styleUrls: ['./list-vouchers.component.scss']
})
export class ListVouchersComponent implements AfterViewInit {
  @Input('wellId')
  wellId: number = 0;
  processing = false;
  flatResults: IVoucherSearchResult[] = [];
  searchResults: any[] = [];
  displayedColumns: string[] = ['id', 'applicationType', 'applicationStatus', 'contactAddress', 'applicantContactName', 'voucherMaxValue', 'redeemed', 'exceedencesDetected'];
  dataSource = new MatTableDataSource<IVoucherSearchResult>(this.flatResults);
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;
  pageSize = 10;
  resultSize: number = 0;

  filterTable(event: Event) {
    let value = (event.target as HTMLInputElement).value;
    this.dataSource.filter = value.trim().toLowerCase();
  }
  search: VoucherSearch = {
    voucherId: '',
    voucherApplicationId: '',
    applicationIdentifier: '',
    wellId: 0,
    testingNeed: '',
    contact: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    county: '',
    email: '',
    phone: '',
    redeemed: false,
    exceedencesDetected: false,
    status: '',
    wellTag: '',
    wellLog: '',
    receivedStartDate: '',
    receivedEndDate: '',
    type: '',
    includeLetters: false
  }

  constructor(public dialog: MatDialog, public voucherService: VoucherService) {
  }

  ngAfterViewInit(): void {
    this.loadVouchers();
  }

  loadVouchers() {
    this.processing = true;
    this.search.wellId = this.wellId;
    this.voucherService.Search(this.search).subscribe(
      result => {
        this.searchResults = result;
        this.resultSize = result.length;
        this.processing = false;
      },
      error => {
        this.processing = false;
      },
      () => {
        this.flatResults = this.getFlatSearchResults();
        this.dataSource = new MatTableDataSource<IVoucherSearchResult>(this.flatResults);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  getFlatSearchResults(): any[] {
    return this.searchResults.map((result: any) => {
      return {
        voucherId: result.data?.voucherId || null,
        applicationIdentifier: result.data?.applicationIdentifier || null,
        applicantContactName: result.data?.applicantContactName || null,
        applicationType: result.data?.applicationType || null,
        applicationStatus: result.data?.applicationStatus || null,
        applicantMailingAddress: result.data?.applicantMailingAddress || null,
        applicantState: result.data?.applicantState || null,
        applicantCity: result.data?.applicantCity || null,
        applicantZip: result.data?.applicantZip || null,
        voucherMaxValue: result.data?.voucherMaxValue || null,
        redeemed: result.data?.redeemed || null,
        exceedencesDetected: result.data?.exceedencesDetected || null,
      } as any;
    });
  }

  editVoucher(voucherId: number) {
    const dialogRef = this.dialog.open(DialogEditVoucherComponent, {
      width: '90%',
      data: voucherId,
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
}